// Module
var code = "<div class=\"panel panel-default\"> <div class=panel-body> <div ng-transclude></div> </div> </div>";
// Exports
module.exports = code;